<template>
  <BlockEffects>
    <BlockTypeHeading v-if='type=="heading"' :block='block' />
    <BlockTypeText v-if='type=="text"' :block='block' />
    <BlockTypeContact v-if='type=="imagetext"' :block='block' :context='context'/>
    <BlockTypeIntro v-if='type=="intro"' :block='block' />
    <BlockTypeImage v-if='type=="customimage"' :block='block' :context='context' />
    <BlockEmailForm v-if='type=="emailform"' :block='block' />
  </BlockEffects>
</template>

<script setup>
const props = defineProps({
  block: {
    type: Object,
    required: true,
    default: {}
  },
  context: {
    type: Object,
    required: false,
    default: {}
  },
  filter: {
    type: [String, Boolean],
  }
});
const type = computed(()=> props.block.type);
</script>
